import React, { useCallback } from 'react'
import { Badge, BadgeProps, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { OverlayInjectedProps } from 'react-bootstrap/Overlay'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan, faInfo } from '@fortawesome/free-solid-svg-icons'
import { uniqueId } from 'lodash'

import { OfferType } from '@monorepo/interfaces'

type RefundInfoPropsType = BadgeProps & {
  item: OfferType
}
export const RefundInfo: React.FC<RefundInfoPropsType> = ({
  item,
  ...props
}) => {
  // const variant = !item.isReturnAllowed
  //   ? 'danger'
  //   : item.returnPercent > 0
  //   ? 'warning'
  //   : 'info'

  const renderTooltip = useCallback(
    (props: OverlayInjectedProps) => (
      <Tooltip id={uniqueId('tooltip-')} {...props}>
        {item.isReturnAllowed ? (
          <>
            {item.returnPercent > 0 && (
              <p className="my-0 text-justify">Возврат {item.returnPercent}%</p>
            )}
            {Boolean(item.returnConditions) && (
              <p className="my-0 text-justify" style={{ lineHeight: '1em' }}>
                <small>{item.returnConditions}</small>
              </p>
            )}
          </>
        ) : (
          'Возврат запрещён'
        )}
      </Tooltip>
    ),
    [item.isReturnAllowed, item.returnConditions, item.returnPercent]
  )

  const isShow: Boolean =
    !item.isReturnAllowed ||
    item.returnPercent > 0 ||
    Boolean(item.returnConditions)

  return isShow ? (
    <OverlayTrigger placement="auto" overlay={renderTooltip}>
      <Badge {...props}>
        {item.isReturnAllowed ? (
          item.returnPercent > 0 ? (
            <>{item.returnPercent}%</>
          ) : (
            <FontAwesomeIcon icon={faInfo} />
          )
        ) : (
          <FontAwesomeIcon icon={faBan} />
        )}
      </Badge>
    </OverlayTrigger>
  ) : null
}
